import { visibleBrandBounds } from '../components/theme/BrandAsset';

// Chrome controls the tab size. Fill its square icon with the visible artwork,
// preserving aspect ratio and leaving the saved upload/header logo untouched.
export function renderTabFavicon(image, color) {
  const bounds = visibleBrandBounds(image);
  if (!bounds) return null;
  const [x, y, width, height] = bounds.viewBox.split(' ').map(Number);
  const canvas = document.createElement('canvas');
  canvas.width = 64; canvas.height = 64;
  const context = canvas.getContext('2d');
  if (!context) return null;
  const scale = 62 / Math.max(width, height);
  const targetWidth = width * scale, targetHeight = height * scale;
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = 'high';
  context.drawImage(image, x, y, width, height,
    (64 - targetWidth) / 2, (64 - targetHeight) / 2, targetWidth, targetHeight);
  // Theme-color silhouette; retain the source transparency and cut-outs.
  if (/^#[0-9a-f]{6}$/i.test(color || '')) {
    context.globalCompositeOperation = 'source-in';
    context.fillStyle = color;
    context.fillRect(0, 0, 64, 64);
  }
  return canvas.toDataURL('image/png');
}

export function installTabFavicon(src, color) {
  let icon = document.querySelector('link[rel="icon"]');
  if (!icon) {
    icon = document.createElement('link');
    icon.rel = 'icon';
    document.head.appendChild(icon);
  }
  // Show the original immediately, also serving as the fallback on decode or
  // canvas failure. A later preview/tenant change must win over an older load.
  icon.href = src;
  icon.type = 'image/png';
  icon.removeAttribute('sizes');
  let active = true;
  const image = new Image();
  image.onload = () => {
    if (!active) return;
    try {
      const normalized = renderTabFavicon(image, color);
      if (normalized) {
        icon.href = normalized;
        icon.setAttribute('sizes', '64x64');
      }
    } catch { /* Keep the original when image pixels cannot be read. */ }
  };
  image.src = src;
  return () => { active = false; image.onload = null; };
}
